import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";

// Layouts
import AuthLayout from "components/Layouts/AuthLayout";
import AppLayout from "components/Layouts/AppLayout";

// Pages (Public)
import AuthPage from "pages/auth/AuthPage";
import ForgotPage from "pages/auth/ForgotPassword";

// Pages (Protected)
import AppPage from "pages/app/AppPage";
import Partners from "pages/app/Partners";
import PartnerInfo from "pages/app/Partners/PartnersInfo";
import Transactions from "pages/app/Transactions";
import TxnInfo from "pages/app/Transactions/EarningPartner";
import Products from "pages/app/Products";
import Campaigns from "pages/app/Campaigns";
import CampaignsForm from "pages/app/Campaigns/CampaignsForm";
import Commission from "pages/app/Commissions";
import Contents from "pages/app/Contents";
import ContentForm from "pages/app/Contents/ContentForm";
import Admins from "pages/app/Admins";
import AdminsForm from "pages/app/Admins/form";
import Profile from "pages/app/Profile";
import Help from "pages/app/Help";
import Manual from "pages/app/Manual";

// Error Pages
import PagesMaintenance from "pages/utility/pages-maintenance";
import PagesComingsoon from "pages/utility/pages-comingsoon";
import Pages404 from "pages/utility/pages-404";
import Pages500 from "pages/utility/pages-500";
import PrintComponent from "components/PrintComponent";

// Main layout wrapper for authenticated routes
const AuthenticatedLayout = () => {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
};

const ApplicationLayout = () => {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

// Main App Routes component
const AppRoutes = () => {
  const { isAuth, isInitialize } = useAuth();

  // Show loading indicator while checking auth status
  if (isInitialize) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuth) {
    return (
      <Routes>
        <Route
          element={
            <PublicRoute>
              <AuthenticatedLayout />
            </PublicRoute>
          }
        >
          <Route path="/" element={<AuthPage />} />
          <Route path="/forgot-password" element={<ForgotPage />} />
        </Route>

        <Route path="/pages-maintenance" element={<PagesMaintenance />} />
        <Route path="/pages-comingsoon" element={<PagesComingsoon />} />
        <Route path="/pages-500" element={<Pages500 />} />
        <Route path="/print" element={<PrintComponent />} />
        <Route path="*" element={<Pages404 />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute>
            <ApplicationLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<AppPage />} />

        <Route path="/partners" element={<Partners />} />
        <Route path="/partners/:id" element={<PartnerInfo />} />

        <Route path="/transactions" element={<Transactions />} />
        <Route path="/transactions/:id" element={<TxnInfo />} />

        <Route path="/products" element={<Products />} />

        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/campaigns/form" element={<CampaignsForm />} />
        <Route path="/campaigns/form/:id" element={<CampaignsForm />} />

        <Route path="/commission" element={<Commission />} />

        <Route path="/contents" element={<Contents />} />
        <Route path="/contents/form" element={<ContentForm />} />
        <Route path="/contents/form/:id" element={<ContentForm />} />

        <Route path="/admin" element={<Admins />} />
        <Route path="/admin/form" element={<AdminsForm />} />
        <Route path="/admin/form/:id" element={<AdminsForm />} />

        <Route path="/profile" element={<Profile />} />
        {/* <Route path="/profile/address" element={<ProfileFormAddress />} /> */}
        <Route path="/help" element={<Help />} />
        <Route path="/manual" element={<Manual />} />
      </Route>
      <Route path="/pages-maintenance" element={<PagesMaintenance />} />
      <Route path="/pages-comingsoon" element={<PagesComingsoon />} />
      <Route path="/pages-500" element={<Pages500 />} />
      <Route path="/print" element={<PrintComponent />} />
      <Route path="*" element={<Pages404 />} />
    </Routes>
  );
};

export default AppRoutes;
